import Store from "~/common/Store";
import MarketingEventHelpers from "../MarketingHelpers/MarketingEventHelpers";
import { loadedAnalytics } from "./loadAnalyticsBrowser";
import { getCheckedStatusAndSendNewsLetterEvent } from "./EmailEvents";

const customerIoActionMap = {
  account_login: "login_email",
  new_account_registration: "new_account_email",
};

export const sendCustomerIoAccountEvent = (
  action: keyof typeof customerIoActionMap,
  email: string,
) => {
  const keyName = customerIoActionMap[action];
  if (loadedAnalytics) {
    const { user } = Store.getState();
    loadedAnalytics.track(action, {
      event_timestamp: MarketingEventHelpers.getCurrentTimeStamp(),
      is_internal: user.analyticsData.is_internal,
      [keyName]: email.toLowerCase(),
    });
  }
};

const attachFormAndButtonEvents = (
  form: HTMLElement,
  button: HTMLElement,
  event: keyof typeof customerIoActionMap,
  additonalEventCb?: (email: string) => void,
) => {
  const email = document.getElementById("email") as HTMLInputElement;
  const password = document.getElementById("password") as HTMLInputElement;
  if (button) {
    button.addEventListener("click", () => {
      if (email && password) {
        sendCustomerIoAccountEvent(event, email.value);
        additonalEventCb?.(email.value);
      }
    });
  }
  if (form) {
    form.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        if (email && password) {
          sendCustomerIoAccountEvent(event, email.value);
          additonalEventCb?.(email.value);
        }
      }
    });
  }
};

export const getElementsAndAttachEvents = () => {
  const loginForm = document.getElementById("loginForm");
  const loginButton = document.getElementById("the_login_button");
  const registerButton = document.getElementById("complete_registration");
  const registerForm = document.getElementById("billing_shipping_form");
  if (loginForm && loginButton) {
    attachFormAndButtonEvents(loginForm, loginButton, "account_login");
  }
  if (registerForm && registerButton) {
    attachFormAndButtonEvents(
      registerForm,
      registerButton,
      "new_account_registration",
      getCheckedStatusAndSendNewsLetterEvent,
    );
  }
};
